/** Classes do item da sidebar: ícone com legenda abaixo, área de toque ≥ 44 px. */
export const RAIL_ITEM_CLASS =
  'flex w-20 shrink-0 flex-col items-center gap-1 rounded-lg px-0.5 py-2 text-sidebar-foreground transition-colors outline-none hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-[3px] focus-visible:ring-sidebar-ring/30';
